const translations = {
  en: {
    // NFC owner-tags
    nfcActivateTitle: "Activate your tags",
    nfcActivateDesc: "Enter your pack code to link its NFC tags to your account. You only do this once per pack — afterwards, just stick the tags on your belongings.",
    nfcActivatePackId: "Pack ID",
    nfcActivateCode: "Activation code",
    nfcActivateBtn: "Activate pack",
    nfcActivateBusy: "Activating…",
    nfcActivatedTitle: "Pack activated",
    nfcActivatedDesc: "{count} tags are now linked to your account. Stick them on your things and forget about them.",
    nfcGoRekovr: "Go to Rekovr",
    nfcDone: "Done",
    nfcFoundInactiveTitle: "This tag isn't active",
    nfcFoundInactiveDesc: "We couldn't find an item linked to this tag.",
    nfcFoundSelfTitle: "This item is yours 🙂",
    nfcFoundSelfDesc: "This tag is linked to your own account — nothing to return here.",
    nfcFoundActiveTitle: "Already being returned",
    nfcFoundActiveDesc: "Someone is already helping return this item. Thanks for scanning!",
    nfcFoundTitle: "You found someone's item",
    nfcFoundDesc: "Confirm you have it and we'll connect you with the owner to return it — you'll earn a reward for helping.",
    nfcFoundNoteLabel: "Add a note (optional)",
    nfcFoundNotePlaceholder: "e.g. Found it at the gym reception",
    nfcFoundPhotoLabel: "Add a photo (optional)",
    nfcFoundPhotoAdded: "Photo added",
    nfcFoundPhotoChoose: "Choose a photo",
    nfcFoundUploading: "Uploading…",
    nfcFoundConfirm: "Confirm — I found this",
    nfcFoundConnecting: "Connecting…",
    nfcFoundPrivacy: "The owner never sees your identity until you agree to coordinate.",
    nfcFoundDoneTitle: "Thanks — you've made someone's day",
    nfcFoundDoneDesc: "We've let the owner know. Open the conversation to arrange the return — we'll also email you if they reply.",
    nfcFoundDoneBtn: "Open the conversation",
    nfcTagEditTitle: "Your tag",
    nfcTagEditDesc: "Add details so you know what's on this tag — and set a reward to motivate whoever finds it. Everything is optional.",
    nfcTagAiHint: "Tip: add a photo and let AI fill in the name and description.",
    nfcTagNameLabel: "Name",
    nfcTagNamePlaceholder: "e.g. Brown leather wallet",
    nfcTagDescLabel: "Description",
    nfcTagRewardLabel: "Reward (€)",
    nfcTagSave: "Save details",
    nfcTagSaving: "Saving…",
    nfcTagSavedTitle: "Details saved",
    nfcTagSavedDesc: "Great — now you'll know exactly what this tag is on, and finders will see it too.",
    // Navigation
    home: "Home",
    myItems: "My Items",
    messages: "Messages",
    notifications: "Notifications",
    profile: "Profile",
    settings: "Settings",
    report: "Report",
    // Auth
    login: "Log In",
    register: "Sign Up",
    loginWithGoogle: "Continue with Google",
    email: "Email",
    password: "Password",
    name: "Name",
    orContinueWith: "or continue with",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    logout: "Log Out",
    loginTagline: "Recover what matters.",
    orDivider: "or",
    termsNotice: "By continuing you agree to our Terms and Privacy Policy.",
    // Email verification
    verifyYourEmail: "Verify your email",
    verificationCodeSent: "We sent a 6-digit code to",
    enterCode: "Enter the code",
    codePlaceholder: "000000",
    verify: "Verify",
    verifying: "Verifying...",
    resendCode: "Resend code",
    codeSent: "Code sent!",
    codeExpired: "Code expired. Request a new one.",
    invalidCode: "Invalid code. Please try again.",
    emailVerified: "Email verified!",
    backToLogin: "Back to login",
    magicLinkExpired: "This link has expired. Please log in manually.",
    loggingIn: "Logging in...",
    // Home
    welcomeTitle: "Recover what matters.",
    welcomeSubtitle: "The lost & found platform.",
    iLostSomething: "I lost something",
    iFoundSomething: "I found something",
    howItWorks: "How it works",
    stepReport: "Report",
    stepReportDesc: "Describe your item with details, photos, and location.",
    stepAiMatching: "AI Matching",
    stepAiMatchingDesc: "Our AI compares lost and found items automatically.",
    stepSecureReturn: "Secure Return",
    stepSecureReturnDesc: "Chat privately, meet safely, and complete the exchange.",
    reportAndLetAiFind: "Report and let AI find it",
    helpReturnToOwner: "Help return it to the owner",
    // Claim invitation (operator-initiated)
    claimInviteTitle: "Claim what you lost",
    claimInviteWrongAccount: "You're signed in with a different account on this device.",
    claimInviteWrongAccountWho: 'Signed in as {current} · invited: {invited}',
    claimInviteSwitchAccount: 'Sign out and continue as {invited}',
    claimInviteIntro: "{org} thinks they found something of yours. Check that it fits, then continue to prove it's yours.",
    claimInviteIntroNoOrg: "An organisation thinks they found something of yours. Check that it fits, then continue to prove it's yours.",
    claimInviteFoundBy: "Found by {org}",
    claimInviteFoundItem: "Found item",
    claimInviteVeilNote: "The real title and the photo stay hidden until you answer a few questions about the item.",
    claimInviteNameLabel: "Your name",
    claimInviteNamePlaceholder: "How should we call you?",
    claimInviteAccountNote: "We'll set up your account with {email}.",
    claimInviteContinue: "Continue",
    claimInviteAccepting: "Setting things up\u2026",
    claimInviteNotMine: "If this isn't yours, just close this page. Nothing happens.",
    claimInviteExpiredTitle: "This link has expired",
    claimInviteExpiredBody: "Invitations last 48 hours. Call the organisation again and they can send you a new one.",
    claimInviteCancelledTitle: "This invitation was withdrawn",
    claimInviteCancelledBody: "The organisation cancelled it. Get in touch with them if you think that's a mistake.",
    claimInviteGoneTitle: "This item has already been handed over",
    claimInviteGoneBody: "Someone collected it before you got here. Contact the organisation if you believe it was yours.",
    claimInviteNotFoundTitle: "We can't find this invitation",
    claimInviteNotFoundBody: "The link may be incomplete. Try opening it again from the email, or ask the organisation to resend it.",
    // Home task tray
    trayGreeting: "Hi, {name}",
    trayAllCaughtUp: "All caught up",
    trayAllCaughtUpDesc: "Nothing pending. Your listings are still searching.",
    trayThingsToDoOne: "1 thing to do",
    trayThingsToDoMany: "{count} things to do",
    trayYourTurn: "Your turn",
    trayInProgress: "In progress",
    trayNothingElse: "Nothing else in motion.",
    trayLoadFailed: "We couldn't load your tasks.",
    trayRetry: "Try again",
    publishLostShort: "I lost\u2026",
    publishFoundShort: "I found\u2026",
    trayFoundAt: "Found in {place}",
    trayGroupedHint: "Choose where to start",
    trayFinderRole: "You're the finder",
    trayReleasesPayment: "Releases the payment",
    taskAnswerVerification: "Answer the verification questions",
    taskAnswerVerificationOne: "Answer 1 verification question",
    taskAnswerVerificationMany: "Answer {count} verification questions",
    taskProvideProof: "Send more proof of ownership",
    taskChooseDelivery: "Choose how to get it back",
    taskPayRecovery: "Complete the recovery payment",
    taskShowPickupQr: "Show the QR when you collect it",
    taskConfirmRecovery: "Confirm you got it back",
    taskShipmentIssue: "There's a problem with the delivery",
    taskDecideMatch: "Decide on a new match",
    taskReviewAnswers: "Review the verification answers",
    taskReviewAnswersOne: "Review 1 verification answer",
    taskReviewAnswersMany: "Review {count} verification answers",
    taskGroupedAnswerVerification: "{count} matches to verify",
    taskGroupedReviewAnswers: "{count} matches to review",
    taskGroupedDecideMatch: "{count} matches to decide on",
    taskGroupedGeneric: "{count} things pending",
    waitFinder: "Waiting for the finder to decide",
    waitClaimant: "Waiting for the owner",
    waitShipmentPreparing: "Getting the parcel ready",
    waitShipmentOnTheWay: "On its way",
    waitHandover: "Waiting for the handover",
    openMatchesBadge: "{count} open",
    // Publish
    publishLost: "Report Lost Item",
    publishFound: "Report Found Item",
    reportAnItem: "Report an Item",
    reportLostDesc: "Report a lost item and let AI search for it",
    reportFoundDesc: "Help return it to the rightful owner",
    title: "Title",
    titlePlaceholder: "e.g. Black iPhone 14 Pro",
    description: "Description",
    descriptionPlaceholder: "Describe the item with as much detail as possible...",
    location: "Location",
    locationPlaceholder: "Search for an address...",
    dateTime: "Date & Time",
    whenDidThisHappen: "When did this happen?",
    tapMapOrSearch: "Tap the map or search an address",
    photos: "Photos",
    photosHint: "Up to 5 photos (recommended)",
    maxPhotos: "Maximum 5 photos",
    aiGenerateDescription: "Auto-fill title & description",
    aiGenerating: "Analyzing photos...",
    aiGenerateHint: "Add photos to auto-generate title and description",
    aiGenerateSuccess: "Description generated!",
    aiGenerateError: "Could not generate description",
    reward: "Reward",
    rewardHint: "Minimum 5 EUR if specified",
    rewardPlaceholder: "0",
    howRewardsWork: "How rewards work",
    rewardExplanation1: "The reward incentivizes finders to return your item. A fair reward increases your chances.",
    rewardExplanation2: "You only pay if you recover your item. No match = no charge.",
    rewardExplanation3: "Money is held securely by Rekovr until you confirm recovery. Cancel anytime for a full refund.",
    rewardCommission: "The finder receives your reward in full. Rekovr's fee is added on top and shown before you pay.",
    rewardToFinder: "Reward to the finder",
    rewardYouWillPay: "You will pay",
    rewardEstimateNote: "Approximate: the final fee depends on the item category.",
    rewardMotivationTitle: "Set a reward for the finder",
    rewardMotivationBody: "Items with a reward are significantly more likely to be returned. You only pay if your item is successfully recovered — no recovery, no charge.",
    rewardSkip: "Skip — no reward",
    rewardNoRewardNote: "You can still recover your item without a reward, but your chances are lower.",
    next: "Next",
    back: "Back",
    submit: "Submit",
    publishing: "Publishing...",
    lostItemReported: "Lost item reported! Searching for matches...",
    foundItemReported: "Found item reported!",
    readyToSubmit: "Everything looks good — ready to submit!",
    step: "Step",
    of: "of",
    itemDetails: "Item Details",
    locationAndTime: "Location & Time",
    reviewAndSubmit: "Review & Submit",
    summary: "Summary",
    type: "Type",
    // Items
    lost: "Lost",
    found: "Found",
    active: "Active",
    recovered: "Recovered",
    returned: "Returned",
    archived: "Archived",
    matched: "Matched",
    noItems: "No items yet",
    noItemsHint: "Start by reporting a lost or found item",
    category: "Category",
    postedOn: "Posted on",
    expiresOn: "Expires on",
    // Matches
    possibleMatch: "Possible Match",
    matchScore: "Match Score",
    matchDetails: "Match Details",
    accept: "Accept",
    reject: "Reject",
    provideProof: "Provide More Info",
    matchAccepted: "Match accepted!",
    matchRejected: "Match rejected",
    proofSubmitted: "Proof submitted",
    contactInfoDetected: "We detected contact information in your text. For your safety, this information won't be visible to the other party.",
    continueToPayment: "Continue to Payment",
    openChat: "Open Chat",
    additionalInfo: "Additional Information",
    proofPlaceholder: "Describe additional details that prove ownership...",
    rewardAmount: "Reward amount",
    totalToPay: "Total to pay",
    breakdownDetails: "See breakdown",
    platformFee: "Platform fee",
    requestMoreInfo: "Request More Information",
    infoRequested: "Info request sent!",
    infoAlreadyRequested: "Info Already Requested",
    infoRequestedTitle: "More information needed",
    infoRequestedMessage: "The finder needs more details to verify your ownership. Please provide additional information using the button below.",
    confirmRequestInfo: "This will notify the owner that you need more information to verify their ownership. They will be asked to provide additional details.",
    foundByOrg: "Found by",
    noMatches: "No matches yet",
    noMatchesHint: "We'll notify you when we find a potential match",
    addPhotos: "Add photos",
    addPhotosHint: "Items with photos are far more likely to be matched",
    matchVerdictHigh: "Strong match",
    matchVerdictMedium: "Possible match",
    matchVerdictLow: "Weak match",
    showMore: "Show more",
    showLess: "Show less",
    apart: "apart",
    protectedVersion: "Summary version",
    answerQuestions: "Answer the questions",
    yourAnswers: "Your answers",
    activeMatches: "Active",
    allMatches: "All",
    loadMore: "Load more",
    pending: "Pending",
    pending_verification: "Verification",
    pending_review: "Under Review",
    accepted: "Accepted",
    rejected: "Rejected",
    dismissed: "Dismissed",
    paid: "Paid",
    // Verification
    pendingVerification: "Verification",
    verificationRequired: "Ownership Verification",
    verificationDescription: "Please answer a few questions to verify you are the owner of this item. This helps ensure items are returned to the right person.",
    photosLockedMessage: "Photos will be unlocked after verification",
    publicCopyPendingTitle: "Found item",
    publicCopyPendingDesc: "The safe description of this listing is still being prepared.",
    claimantPendingMessage: "The finder is reviewing your claim. They may accept it directly, or ask you a few questions to confirm the item is yours.",
    claimantPendingVerificationMessage: "Answer the verification questions below to prove the item is yours. Only the real owner should be able to.",
    photosLockedClosedMessage: "Photos stay hidden on a closed match",
    submitVerification: "Submit Answers",
    verificationSubmitted: "Answers submitted successfully!",
    verificationFailed: "Failed to submit answers. Please try again.",
    answerPlaceholder: "Type your answer...",
    // M3+ — AI recommendation card for the finder
    aiRecommendsSkip: "AI recommends accepting directly",
    aiRecommendsVerify: "AI recommends asking verification questions",
    acceptDirectly: "Accept directly",
    acceptAnyway: "Accept anyway",
    askVerificationQuestions: "Ask verification questions",
    verificationRequested: "Verification requested",
    finderDecisionAdvisory: "If you accept without verification, you trust that the owner's description matches your item. Verification is a quick way to avoid mistakes.",
    noVerificationQuestionsAvailable: "No verification questions could be generated for this match.",
    // M4 — free-text fallback
    freetextFallbackBody: "Describe everything you remember about your item: contents, distinctive marks, where and when you lost it, anything that helps confirm it's yours.",
    freetextPlaceholder: "Describe your item in detail...",
    submitDescription: "Submit description",
    pendingReview: "Under Review",
    pendingReviewClaimantTitle: "Answers Submitted",
    pendingReviewClaimantMessage: "Your answers have been submitted and are being reviewed. You'll be notified once the finder makes a decision.",
    verificationPassedClaimantTitle: "Verification Passed",
    verificationPassedClaimantMessage: "Thanks! We have everything we need from you. The finder will now review the match — they may accept it directly or ask you for some extra details. We'll notify you as soon as there's an update.",
    verificationScore: "Verification Score",
    verificationDetails: "Verification Details",
    claimantAnswer: "Claimant's answer",
    aiAssessment: "AI Assessment",
    verificationHigh: "High confidence",
    verificationMedium: "Needs review",
    verificationLow: "Low confidence",
    // Payment
    makePayment: "Make Payment",
    recoveryFee: "Recovery fee",
    recoveryCoveredByOrg: "No payment needed",
    recoveryCoveredByOrgDesc: "The service cost is covered by the organization. Enjoy the recovery on us!",
    recoveryCoveredByOrgDescWithName: "The service cost is covered by {name}. Enjoy the recovery on us!",
    betaFreeRecoveryTitle: "Free recovery during beta",
    betaFreeRecoveryDesc: "We're in beta — recoveries are free for now. Once the finder accepts, you'll be able to chat with them directly without any payment.",
    betaFreeNoReward: "Recovery is free during beta — no need to set a reward.",
    finderWaitingVerificationTitle: "Verification requested",
    finderWaitingVerificationDesc: "Waiting for the claimant to answer the verification questions. You'll be notified as soon as they reply.",
    recoveryCoveredByOrgPickupTitle: "Pickup instructions",
    recoveryCoveredByOrgPickupHint: "Show the QR code below at the venue to collect your item.",
    feeLoading: "Calculating fee...",
    pickupQR: "Pickup QR Code",
    pickupQRDescription: "Show this QR code at the venue to collect your item",
    downloadQR: "Download QR Code",
    pickupCodeLabel: "Or read the code",
    pickupCodeHint: "If staff can't scan the QR, read this code out loud or copy it.",
    copyPickupCode: "Copy pickup code",
    copied: "Copied to clipboard",
    paymentHeld: "Payment Held",
    confirmRecovery: "I've recovered my item",
    cancelPayment: "Cancel & Refund",
    paymentAmount: "Payment Amount",
    commission: "Rekovr Commission",
    finderReceives: "Finder Receives",
    paymentMock: "This is a simulated payment for the MVP",
    paymentRedirectNote: "You'll be redirected to Stripe to complete the payment securely. The funds will be held until you confirm item recovery.",
    recoveryConfirmed: "Recovery confirmed! Thank you!",
    paymentRefunded: "Payment refunded",
    processingPayment: "Processing Payment...",
    pleaseWaitPayment: "Please wait while we confirm your payment",
    paymentSuccessful: "Payment Successful!",
    paymentExpired: "Payment Expired",
    paymentError: "Payment Error",
    viewMyItems: "View My Items",
    backToMyItems: "Back to My Items",
    // Chat
    typeMessage: "Type a message...",
    send: "Send",
    noMessages: "No messages yet",
    startConversation: "Start the conversation to arrange the return",
    activeChats: "Active Chats",
    noChats: "No active chats",
    noChatsHint: "Chats will appear here after payment for a match",
    // Notifications
    noNotifications: "No notifications",
    noNotificationsHint: "You'll receive notifications about matches and messages",
    markAllRead: "Mark all as read",
    // Profile
    memberSince: "Member since",
    itemsLost: "Items Lost",
    itemsFound: "Items Found",
    itemsRecovered: "Items Recovered",
    ratings: "Ratings",
    noRatings: "No ratings yet",
    rateUser: "Rate this user",
    // Linked documents
    myDocuments: "My Documents",
    myDocumentsHint: "Link your ID documents so we can notify you if any are found.",
    addDocument: "Add document",
    noDocumentsYet: "No documents linked yet",
    linkedOn: "Linked on",
    docTypeIdCard: "ID Card",
    docTypePassport: "Passport",
    docTypeDrivingLicense: "Driving License",
    docTypeOther: "Other",
    docTypeLabel: "Document label (optional)",
    docTypeLabelHint: "E.g. \"DNI\", \"UK Passport\" — only used to display",
    docNumber: "Document number",
    docNumberHint: "Spaces and dashes are ignored",
    docPrivacyNotice: "Only an irreversible hash is stored. The number is never saved in plain text.",
    maxDocumentsReached: "You've reached the limit of 5 linked documents",
    documentAlreadyLinked: "This document is already linked",
    confirmRemoveDocument: "Remove this linked document?",
    // Linked documents — photo-based verification
    linkDocPrivacyNotice: "We scan the photo to verify the document, store only an irreversible hash of the number, and discard the image. Nothing is saved on our servers.",
    linkDocUploadHint: "Upload a photo of your DNI, NIE, passport or driving license. You can add a second photo for the back side.",
    linkDocSelectPhoto: "Select photo",
    linkDocFilesSelected: "{count} photo(s) selected",
    linkDocVerifyAndLink: "Verify and link",
    linkDocVerifying: "Verifying…",
    linkDocInvalidFile: "Invalid image. Please upload a JPG, PNG or WebP.",
    linkDocNotDetected: "We couldn't read an identity document in this photo. Try a sharper shot.",
    linkDocNotGenuine: "This doesn't look like an authentic document. We don't accept printouts, photocopies, or screen captures.",
    linkDocUnsupportedType: "Only national ID cards, passports and driving licenses can be linked.",
    linkDocNameMismatch: "The name on the document doesn't match your profile name. Update your profile first if needed.",
    linkDocDuplicate: "This document is already linked to your profile.",
    // Camí A — Claim identified item (Phase 6B)
    claimIdentifiedTitle: "Claim your document",
    claimIdentifiedIntro: "A found item matches a document linked to your profile. Review the details and claim it.",
    claimIdentifiedProof: "No verification questions needed — the document number matches cryptographically.",
    claimIdentifiedConfirm: "Confirm and claim",
    claimIdentifiedSubmitting: "Claiming…",
    claimExternallyContactedTitle: "The finder has already contacted you",
    claimExternallyContactedBody: "They may have reached out by phone or email. You can still claim here to handle the recovery through the platform.",
    // Identified owner (C2C publish flow)
    identifiedOwner: "Identified owner",
    identifiedOwnerHintC2C: "If the found item contains an ID document, scan it to notify its owner directly. The photo is processed in memory and never stored.",
    identifiedOwnerUploadBtn: "Scan ID document",
    identifiedOwnerExtracting: "Extracting data...",
    identifiedOwnerNotDetected: "No identity document detected. Try a clearer image.",
    identifiedOwnerRemove: "Remove identified owner",
    identifiedOwnerInvalidFile: "Unsupported file type.",
    identifiedOwnerTooLarge: "Image too large (max 10MB).",
    identifiedOwnerPrivacyC2C: "We protect the owner's privacy. The document data is stored encrypted. After submitting, you will NOT be able to see this information again — only the verified owner will.",
    docTypeField: "Document type",
    docNumberField: "Document number",
    ownerNameField: "Owner name",
    // Settings
    language: "Language",
    english: "English",
    spanish: "Spanish",
    catalan: "Catalan",
    saveChanges: "Save Changes",
    dangerZone: "Danger Zone",
    deleteAccount: "Delete Account",
    // General
    loading: "Loading...",
    error: "Something went wrong",
    errorPageTitle: "Oops! Something went wrong",
    errorPageMessage: "An unexpected error occurred. Please try again.",
    errorLoadData: "Failed to load data. Please try again.",
    goHome: "Go to Home",
    retry: "Retry",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    editLost: "Edit Lost Item",
    editFound: "Edit Found Item",
    itemUpdated: "Item updated! Recalculating matches...",
    close: "Close",
    search: "Search",
    viewDetails: "View Details",
    eurSymbol: "EUR",
    confirmAction: "Are you sure?",
    confirmRejectMatch: "This will reject the match. This action cannot be undone.",
    confirmCancelPayment: "This will cancel the payment and issue a refund.",
    confirmRecoveryAction: "This will confirm that you've recovered your item and release the payment to the finder.",
    noPaymentSession: "No payment session found",
    paymentTimeout: "Payment status check timed out. Please check your notifications.",
    paymentSessionExpired: "Payment session expired. Please try again.",
    timeAgo: "ago",
    justNow: "Just now",
    minutesAgo: "{n}m ago",
    hoursAgo: "{n}h ago",
    daysAgo: "{n}d ago",
    // Wallet
    walletBalance: "Wallet Balance",
    walletHint: "Earn rewards by returning found items. Use your balance to pay for future matches.",
    walletHistory: "Transaction History",
    noTransactions: "No transactions yet",
    showAll: "Show all",
    useWalletBalance: "Use wallet balance",
    availableBalance: "Available",
    fullBalancePayment: "The full amount will be paid from your wallet balance.",
    fromBalance: "From balance",
    fromStripe: "Via Stripe",
    balancePaymentNote: "The payment will be instantly deducted from your wallet. No redirect needed.",
    payWithBalance: "Pay with Balance",
    paidWithBalance: "Paid with wallet balance!",
    // Home delivery flow
    continue: "Continue",
    paymentFailed: "Payment failed",
    deliveryHowReceive: "Get your item back",
    deliveryWhereTo: "Where to?",
    deliveryPickup: "Pick it up",
    deliveryPickupDesc: "At the venue",
    deliveryFree: "Free",
    deliveryShip: "Ship it to me",
    deliveryShipDesc: "Arrives in 2–4 days",
    deliveryFrom: "from {price}",
    deliveryContinueToPay: "Continue · pay {amount}",
    deliveryPickupNote: "Pickup selected · nothing to arrange",
    deliveryShipNextNote: "Next: delivery address & cover",
    deliveryName: "Full name",
    deliveryAddress1: "Address",
    deliveryAddress2: "Apartment, floor (optional)",
    deliveryCity: "City",
    deliveryPostal: "Postal code",
    deliveryCountry: "Country",
    deliveryCountryHint: "2-letter code, e.g. ES",
    deliveryCoverIncluded: "Covered up to {amount} — included",
    deliveryCoverIncludedDesc: "Nothing to fill in unless it's worth more.",
    deliveryExtraCover: "Worth more than {amount}",
    deliveryExtraCoverDesc: "Add extra cover · {rate}% of the value above {amount}",
    deliveryDeclaredValuePlaceholder: "Item value",
    deliveryReviewPay: "Review & pay",
    deliveryAddressIncomplete: "Complete the address to continue",
    deliveryHomeDelivery: "Home delivery",
    deliveryHeavy: "Heavier than 1 kg",
    deliveryHeavyDesc: "Up to 1 kg is included. Tell us the weight to price the courier.",
    deliveryWeightPlaceholder: "Weight",
    deliveryHowShips: "How it ships",
    deliveryRatesLoading: "Getting live shipping prices…",
    deliveryStandard: "Standard delivery",
    deliveryEtaDays: "{days} business days",
    deliveryEtaRange: "{min}–{max} business days",
    deliveryExtraCoverLine: "Extra cover",
    deliveryPayNote: "Covered up to {amount} in transit · secured by Stripe",
    deliveryPayAmount: "Pay {amount}",
    deliveryConfirmPickup: "Confirm pickup",
    deliveryPickupConfirmed: "Pickup confirmed — collect it in person",
    deliveryCoveredPickupNote: "Your organization covers the recovery — nothing to pay for in-person pickup.",
    shipStage_preparing: "Getting your parcel ready",
    shipStage_shipped: "On its way",
    shipStage_out_for_delivery: "Out for delivery",
    shipStage_delivered: "Delivered",
    shipStage_issue: "There's a hold-up",
    shipStage_cancelled: "Shipment cancelled",
    shipToCity: "Shipping to {city}",
    shipTrackingDesc: "We'll keep this updated as it moves",
    shipTrackingNumber: "Tracking number",
    shipTrack: "Track",
    shipCovered: "Covered up to {amount} in transit",
  },
  es: {
    // NFC owner-tags
    nfcActivateTitle: "Activa tus etiquetas",
    nfcActivateDesc: "Introduce el código de tu pack para vincular sus etiquetas NFC a tu cuenta. Solo lo haces una vez por pack — después, solo pega las etiquetas en tus cosas.",
    nfcActivatePackId: "ID del pack",
    nfcActivateCode: "Código de activación",
    nfcActivateBtn: "Activar pack",
    nfcActivateBusy: "Activando…",
    nfcActivatedTitle: "Pack activado",
    nfcActivatedDesc: "{count} etiquetas están ahora vinculadas a tu cuenta. Pégalas en tus cosas y olvídate.",
    nfcGoRekovr: "Ir a Rekovr",
    nfcDone: "Hecho",
    nfcFoundInactiveTitle: "Esta etiqueta no está activa",
    nfcFoundInactiveDesc: "No hemos encontrado ningún objeto vinculado a esta etiqueta.",
    nfcFoundSelfTitle: "Este objeto es tuyo 🙂",
    nfcFoundSelfDesc: "Esta etiqueta está vinculada a tu propia cuenta — no hay nada que devolver aquí.",
    nfcFoundActiveTitle: "Ya se está devolviendo",
    nfcFoundActiveDesc: "Alguien ya está ayudando a devolver este objeto. ¡Gracias por escanear!",
    nfcFoundTitle: "Has encontrado el objeto de alguien",
    nfcFoundDesc: "Confirma que lo tienes y te conectaremos con el dueño para devolverlo — ganarás una recompensa por ayudar.",
    nfcFoundNoteLabel: "Añade una nota (opcional)",
    nfcFoundNotePlaceholder: "p. ej. Lo encontré en la recepción del gimnasio",
    nfcFoundPhotoLabel: "Añade una foto (opcional)",
    nfcFoundPhotoAdded: "Foto añadida",
    nfcFoundPhotoChoose: "Elegir una foto",
    nfcFoundUploading: "Subiendo…",
    nfcFoundConfirm: "Confirmar — lo he encontrado",
    nfcFoundConnecting: "Conectando…",
    nfcFoundPrivacy: "El dueño no ve tu identidad hasta que aceptes coordinar.",
    nfcFoundDoneTitle: "Gracias — le has alegrado el día a alguien",
    nfcFoundDoneDesc: "Hemos avisado al dueño. Abre la conversación para organizar la devolución — también te enviaremos un email si responde.",
    nfcFoundDoneBtn: "Abrir la conversación",
    nfcTagEditTitle: "Tu etiqueta",
    nfcTagEditDesc: "Añade detalles para saber qué hay en esta etiqueta — y pon una recompensa para motivar a quien la encuentre. Todo es opcional.",
    nfcTagAiHint: "Consejo: añade una foto y deja que la IA rellene el nombre y la descripción.",
    nfcTagNameLabel: "Nombre",
    nfcTagNamePlaceholder: "p. ej. Cartera de piel marrón",
    nfcTagDescLabel: "Descripción",
    nfcTagRewardLabel: "Recompensa (€)",
    nfcTagSave: "Guardar detalles",
    nfcTagSaving: "Guardando…",
    nfcTagSavedTitle: "Detalles guardados",
    nfcTagSavedDesc: "Genial — ahora sabrás exactamente qué hay en esta etiqueta, y quien la encuentre también lo verá.",
    // Navigation
    home: "Inicio",
    myItems: "Mis Objetos",
    messages: "Mensajes",
    notifications: "Notificaciones",
    profile: "Perfil",
    settings: "Ajustes",
    report: "Reportar",
    // Auth
    login: "Iniciar Sesion",
    register: "Registrarse",
    loginWithGoogle: "Continuar con Google",
    email: "Correo electronico",
    password: "Contrasena",
    name: "Nombre",
    orContinueWith: "o continuar con",
    alreadyHaveAccount: "Ya tienes una cuenta?",
    dontHaveAccount: "No tienes una cuenta?",
    logout: "Cerrar Sesion",
    loginTagline: "Recupera lo que importa.",
    orDivider: "o",
    termsNotice: "Al continuar aceptas nuestros Terminos y Politica de Privacidad.",
    verifyYourEmail: "Verifica tu email",
    verificationCodeSent: "Hemos enviado un codigo de 6 digitos a",
    enterCode: "Introduce el codigo",
    codePlaceholder: "000000",
    verify: "Verificar",
    verifying: "Verificando...",
    resendCode: "Reenviar codigo",
    codeSent: "Codigo enviado!",
    codeExpired: "Codigo caducado. Solicita uno nuevo.",
    invalidCode: "Codigo incorrecto. Intentalo de nuevo.",
    emailVerified: "Email verificado!",
    backToLogin: "Volver al login",
    magicLinkExpired: "Este enlace ha caducado. Inicia sesión manualmente.",
    loggingIn: "Iniciando sesión...",
    // Home
    welcomeTitle: "Recupera lo que importa.",
    welcomeSubtitle: "La plataforma de objetos perdidos y encontrados.",
    iLostSomething: "He perdido algo",
    iFoundSomething: "He encontrado algo",
    howItWorks: "Como funciona",
    stepReport: "Reportar",
    stepReportDesc: "Describe tu objeto con detalles, fotos y ubicacion.",
    stepAiMatching: "Matching con IA",
    stepAiMatchingDesc: "Nuestra IA compara objetos perdidos y encontrados automaticamente.",
    stepSecureReturn: "Devolucion Segura",
    stepSecureReturnDesc: "Chatea en privado, quedada segura y completa el intercambio.",
    reportAndLetAiFind: "Reporta y deja que la IA lo encuentre",
    helpReturnToOwner: "Ayuda a devolverlo a su dueno",
    // Invitaci\u00f3n a reclamar (iniciada por el operario)
    claimInviteTitle: "Reclama lo que has perdido",
    claimInviteWrongAccount: 'Tienes la sesi\u00f3n iniciada con otra cuenta en este dispositivo.',
    claimInviteWrongAccountWho: 'Sesi\u00f3n de {current} \u00b7 invitado: {invited}',
    claimInviteSwitchAccount: 'Cierra sesi\u00f3n y contin\u00faa como {invited}',
    claimInviteIntro: "{org} cree que ha encontrado algo tuyo. Comprueba que encaja y contin\u00faa para demostrar que es tuyo.",
    claimInviteIntroNoOrg: "Una organizaci\u00f3n cree que ha encontrado algo tuyo. Comprueba que encaja y contin\u00faa para demostrar que es tuyo.",
    claimInviteFoundBy: "Encontrado por {org}",
    claimInviteFoundItem: "Objeto encontrado",
    claimInviteVeilNote: "El t\u00edtulo real y la foto siguen ocultos hasta que respondas unas preguntas sobre el objeto.",
    claimInviteNameLabel: "Tu nombre",
    claimInviteNamePlaceholder: "\u00bfC\u00f3mo te llamamos?",
    claimInviteAccountNote: "Crearemos tu cuenta con {email}.",
    claimInviteContinue: "Continuar",
    claimInviteAccepting: "Prepar\u00e1ndolo todo\u2026",
    claimInviteNotMine: "Si no es tuyo, cierra esta p\u00e1gina. No pasa nada.",
    claimInviteExpiredTitle: "Este enlace ha caducado",
    claimInviteExpiredBody: "Las invitaciones duran 48 horas. Vuelve a llamar a la organizaci\u00f3n y podr\u00e1n enviarte una nueva.",
    claimInviteCancelledTitle: "Esta invitaci\u00f3n se ha retirado",
    claimInviteCancelledBody: "La organizaci\u00f3n la ha cancelado. Ponte en contacto con ellos si crees que es un error.",
    claimInviteGoneTitle: "Este objeto ya se ha entregado",
    claimInviteGoneBody: "Alguien lo recogi\u00f3 antes de que llegaras. Contacta con la organizaci\u00f3n si crees que era tuyo.",
    claimInviteNotFoundTitle: "No encontramos esta invitaci\u00f3n",
    claimInviteNotFoundBody: "Puede que el enlace est\u00e9 incompleto. Vuelve a abrirlo desde el correo o pide que te lo reenv\u00eden.",
    // Bandeja de tareas de inicio
    trayGreeting: "Hola, {name}",
    trayAllCaughtUp: "Todo al d\u00eda",
    trayAllCaughtUpDesc: "No tienes nada pendiente. Tus anuncios siguen buscando.",
    trayThingsToDoOne: "1 cosa por hacer",
    trayThingsToDoMany: "{count} cosas por hacer",
    trayYourTurn: "Te toca a ti",
    trayInProgress: "En curso",
    trayNothingElse: "No tienes nada m\u00e1s en marcha.",
    trayLoadFailed: "No hemos podido cargar tus tareas.",
    trayRetry: "Reintentar",
    publishLostShort: "He perdido\u2026",
    publishFoundShort: "He encontrado\u2026",
    trayFoundAt: "Hallazgo en {place}",
    trayGroupedHint: "Elige por d\u00f3nde empezar",
    trayFinderRole: "Eres quien lo encontr\u00f3",
    trayReleasesPayment: "Libera el pago",
    taskAnswerVerification: "Responde las preguntas de verificaci\u00f3n",
    taskAnswerVerificationOne: "Responde 1 pregunta de verificaci\u00f3n",
    taskAnswerVerificationMany: "Responde {count} preguntas de verificaci\u00f3n",
    taskProvideProof: "Aporta m\u00e1s pruebas de propiedad",
    taskChooseDelivery: "Elige c\u00f3mo quieres recuperarlo",
    taskPayRecovery: "Completa el pago de la recuperaci\u00f3n",
    taskShowPickupQr: "Ense\u00f1a el QR al recogerlo",
    taskConfirmRecovery: "Confirma que lo has recuperado",
    taskShipmentIssue: "Hay un problema con el env\u00edo",
    taskDecideMatch: "Decide sobre un match nuevo",
    taskReviewAnswers: "Revisa las respuestas de verificaci\u00f3n",
    taskReviewAnswersOne: "Revisa 1 respuesta de verificaci\u00f3n",
    taskReviewAnswersMany: "Revisa {count} respuestas de verificaci\u00f3n",
    taskGroupedAnswerVerification: "{count} matches por verificar",
    taskGroupedReviewAnswers: "{count} matches por revisar",
    taskGroupedDecideMatch: "{count} matches por decidir",
    taskGroupedGeneric: "{count} cosas pendientes",
    waitFinder: "Esperando que decida quien lo encontr\u00f3",
    waitClaimant: "Esperando a la persona que lo perdi\u00f3",
    waitShipmentPreparing: "Preparando el env\u00edo",
    waitShipmentOnTheWay: "En camino",
    waitHandover: "Pendiente de la entrega en mano",
    openMatchesBadge: "{count} abiertos",
    // Publish
    publishLost: "Reportar Objeto Perdido",
    publishFound: "Reportar Objeto Encontrado",
    reportAnItem: "Reportar un Objeto",
    reportLostDesc: "Reporta un objeto perdido y deja que la IA lo busque",
    reportFoundDesc: "Ayuda a devolverlo a su legitimo dueno",
    title: "Titulo",
    titlePlaceholder: "Ej: iPhone 14 Pro negro",
    description: "Descripcion",
    descriptionPlaceholder: "Describe el objeto con el maximo detalle posible...",
    location: "Ubicacion",
    locationPlaceholder: "Buscar una direccion...",
    dateTime: "Fecha y Hora",
    whenDidThisHappen: "Cuando ocurrio?",
    tapMapOrSearch: "Toca el mapa o busca una direccion",
    photos: "Fotos",
    photosHint: "Hasta 5 fotos (recomendado)",
    maxPhotos: "Maximo 5 fotos",
    aiGenerateDescription: "Rellenar título y descripción",
    aiGenerating: "Analizando fotos...",
    aiGenerateHint: "Añade fotos para generar título y descripción automáticamente",
    aiGenerateSuccess: "Descripción generada!",
    aiGenerateError: "No se ha podido generar la descripción",
    reward: "Recompensa",
    rewardHint: "Minimo 5 EUR si se especifica",
    rewardPlaceholder: "0",
    howRewardsWork: "Como funcionan las recompensas",
    rewardExplanation1: "La recompensa incentiva a los encontradores a devolver tu objeto. Una recompensa justa aumenta tus posibilidades.",
    rewardExplanation2: "Solo pagas si recuperas tu objeto. Sin match = sin cargo.",
    rewardExplanation3: "El dinero se retiene de forma segura por Rekovr hasta que confirmes la recuperacion. Cancela en cualquier momento para un reembolso completo.",
    rewardCommission: "El encontrador recibe tu recompensa íntegra. La comisión de Rekovr se añade aparte y se muestra antes de pagar.",
    rewardToFinder: "Recompensa para el encontrador",
    rewardYouWillPay: "Pagarás",
    rewardEstimateNote: "Aproximado: la comisión final depende de la categoría del objeto.",
    rewardMotivationTitle: "Ofrece una recompensa al encontrador",
    rewardMotivationBody: "Los objetos con recompensa tienen muchas más posibilidades de ser devueltos. Solo pagas si recuperas tu objeto — sin recuperación, sin cargo.",
    rewardSkip: "Continuar sin recompensa",
    rewardNoRewardNote: "Puedes recuperar tu objeto sin recompensa, pero las posibilidades son menores.",
    next: "Siguiente",
    back: "Atras",
    submit: "Enviar",
    publishing: "Publicando...",
    lostItemReported: "Objeto perdido reportado! Buscando coincidencias...",
    foundItemReported: "Objeto encontrado reportado!",
    readyToSubmit: "Todo listo — ya puedes enviar.",
    step: "Paso",
    of: "de",
    itemDetails: "Detalles del Objeto",
    locationAndTime: "Ubicacion y Hora",
    reviewAndSubmit: "Revisar y Enviar",
    summary: "Resumen",
    type: "Tipo",
    // Items
    lost: "Perdido",
    found: "Encontrado",
    active: "Activo",
    recovered: "Recuperado",
    returned: "Devuelto",
    archived: "Archivado",
    matched: "Con Match",
    noItems: "Sin objetos todavia",
    noItemsHint: "Empieza reportando un objeto perdido o encontrado",
    category: "Categoria",
    postedOn: "Publicado el",
    expiresOn: "Caduca el",
    // Matches
    possibleMatch: "Posible Match",
    matchScore: "Puntuacion del Match",
    matchDetails: "Detalles del Match",
    accept: "Aceptar",
    reject: "Rechazar",
    provideProof: "Aportar mas informacion",
    matchAccepted: "Match aceptado!",
    matchRejected: "Match rechazado",
    proofSubmitted: "Prueba enviada",
    contactInfoDetected: "Hemos detectado información de contacto en tu texto. Por seguridad, esta información no será visible para la otra parte.",
    continueToPayment: "Continuar al Pago",
    openChat: "Abrir Chat",
    additionalInfo: "Informacion Adicional",
    proofPlaceholder: "Describe detalles adicionales que demuestren la propiedad...",
    rewardAmount: "Importe de la recompensa",
    totalToPay: "Total a pagar",
    breakdownDetails: "Ver desglose",
    platformFee: "Comision de la plataforma",
    requestMoreInfo: "Solicitar Más Información",
    infoRequested: "Solicitud de información enviada!",
    infoAlreadyRequested: "Información Ya Solicitada",
    infoRequestedTitle: "Se necesita más información",
    infoRequestedMessage: "El encontrador necesita más detalles para verificar que eres el propietario. Por favor, aporta información adicional usando el botón de abajo.",
    confirmRequestInfo: "Se notificará al propietario que necesitas más información para verificar su propiedad. Se le pedirá que aporte detalles adicionales.",
    foundByOrg: "Encontrado por",
    noMatches: "Sin matches todavia",
    noMatchesHint: "Te notificaremos cuando encontremos un posible match",
    addPhotos: "Sube fotos",
    addPhotosHint: "Los objetos con fotos tienen muchas mas probabilidades de match",
    matchVerdictHigh: "Coincidencia alta",
    matchVerdictMedium: "Coincidencia posible",
    matchVerdictLow: "Coincidencia baja",
    showMore: "Ver mas",
    showLess: "Ver menos",
    apart: "de diferencia",
    protectedVersion: "Version resumida",
    answerQuestions: "Responder las preguntas",
    yourAnswers: "Tus respuestas",
    activeMatches: "Activos",
    allMatches: "Todos",
    loadMore: "Cargar más",
    pending: "Pendiente",
    pending_verification: "Verificación",
    pending_review: "En revisión",
    accepted: "Aceptado",
    rejected: "Rechazado",
    dismissed: "Descartado",
    paid: "Pagado",
    // Verification
    pendingVerification: "Verificación",
    verificationRequired: "Verificación de propiedad",
    verificationDescription: "Por favor, responde unas preguntas para verificar que eres el propietario de este objeto. Esto ayuda a asegurar que los objetos se devuelven a la persona correcta.",
    // M3+ — AI recommendation card for the finder
    aiRecommendsSkip: "La IA recomienda aceptar directamente",
    aiRecommendsVerify: "La IA recomienda hacer preguntas de verificación",
    acceptDirectly: "Aceptar directamente",
    acceptAnyway: "Aceptar igualmente",
    askVerificationQuestions: "Pedir verificación",
    verificationRequested: "Verificación solicitada",
    finderDecisionAdvisory: "Si aceptas sin verificación, confías en que la descripción del propietario coincide con tu objeto. La verificación es una forma rápida de evitar errores.",
    noVerificationQuestionsAvailable: "No se han podido generar preguntas de verificación para este match.",
    // M4 — free-text fallback
    freetextFallbackBody: "Describe todo lo que recuerdes sobre tu objeto: contenido, marcas distintivas, dónde y cuándo lo perdiste, cualquier cosa que ayude a confirmar que es tuyo.",
    freetextPlaceholder: "Describe tu objeto con detalle...",
    submitDescription: "Enviar descripción",
    photosLockedMessage: "Las fotos se desbloquearán después de la verificación",
    publicCopyPendingTitle: "Objeto encontrado",
    publicCopyPendingDesc: "La descripción segura de este anuncio todavía se está preparando.",
    claimantPendingMessage: "El encontrador está revisando tu solicitud. Puede aceptarla directamente o hacerte unas preguntas para confirmar que el objeto es tuyo.",
    claimantPendingVerificationMessage: "Responde las preguntas de verificación de abajo para demostrar que el objeto es tuyo. Solo el propietario real debería poder hacerlo.",
    photosLockedClosedMessage: "Las fotos siguen ocultas en una coincidencia cerrada",
    submitVerification: "Enviar respuestas",
    verificationSubmitted: "¡Respuestas enviadas correctamente!",
    verificationFailed: "Error al enviar las respuestas. Inténtalo de nuevo.",
    answerPlaceholder: "Escribe tu respuesta...",
    pendingReview: "En revisión",
    pendingReviewClaimantTitle: "Respuestas enviadas",
    pendingReviewClaimantMessage: "Tus respuestas han sido enviadas y están siendo revisadas. Te notificaremos cuando el encontrador tome una decisión.",
    verificationPassedClaimantTitle: "Verificación superada",
    verificationPassedClaimantMessage: "¡Gracias! Ya tenemos todo lo que necesitábamos de ti. Ahora el encontrador revisará el match — puede aceptarlo directamente o pedirte algún detalle adicional. Te avisaremos en cuanto haya novedades.",
    verificationScore: "Puntuación de verificación",
    verificationDetails: "Detalles de verificación",
    claimantAnswer: "Respuesta del reclamante",
    aiAssessment: "Evaluación IA",
    verificationHigh: "Alta confianza",
    verificationMedium: "Requiere revisión",
    verificationLow: "Baja confianza",
    // Payment
    makePayment: "Realizar Pago",
    recoveryFee: "Tarifa de recuperación",
    recoveryCoveredByOrg: "No tienes que pagar nada",
    recoveryCoveredByOrgDesc: "El coste del servicio está cubierto por la organización. ¡Disfruta de la recuperación!",
    recoveryCoveredByOrgDescWithName: "El coste del servicio está cubierto por {name}. ¡Disfruta de la recuperación!",
    betaFreeRecoveryTitle: "Recuperación gratuita durante la beta",
    betaFreeRecoveryDesc: "Estamos en beta — las recuperaciones son gratuitas por ahora. En cuanto quien lo haya encontrado acepte, podrás contactar con esa persona directamente sin ningún pago.",
    betaFreeNoReward: "La recuperación es gratuita durante la beta — no hace falta indicar recompensa.",
    finderWaitingVerificationTitle: "Verificación solicitada",
    finderWaitingVerificationDesc: "Esperando a que la persona que ha perdido el objeto responda las preguntas de verificación. Te avisaremos en cuanto conteste.",
    recoveryCoveredByOrgPickupTitle: "Instrucciones de recogida",
    recoveryCoveredByOrgPickupHint: "Muestra el código QR en el lugar de recogida para recuperar tu objeto.",
    feeLoading: "Calculando tarifa...",
    pickupQR: "Código QR de recogida",
    pickupQRDescription: "Muestra este código QR en el recinto para recoger tu objeto",
    downloadQR: "Descargar código QR",
    pickupCodeLabel: "O dicta el código",
    pickupCodeHint: "Si no pueden escanear el QR, dicta este código o cópialo.",
    copyPickupCode: "Copiar código de recogida",
    copied: "Copiado al portapapeles",
    paymentHeld: "Pago Retenido",
    confirmRecovery: "He recuperado mi objeto",
    cancelPayment: "Cancelar y Reembolsar",
    paymentAmount: "Importe del Pago",
    commission: "Comision Rekovr",
    finderReceives: "El Encontrador Recibe",
    paymentMock: "Este es un pago simulado para el MVP",
    paymentRedirectNote: "Seras redirigido a Stripe para completar el pago de forma segura. Los fondos se retendran hasta que confirmes la recuperacion del objeto.",
    recoveryConfirmed: "Recuperacion confirmada! Gracias!",
    paymentRefunded: "Pago reembolsado",
    processingPayment: "Procesando Pago...",
    pleaseWaitPayment: "Por favor espera mientras confirmamos tu pago",
    paymentSuccessful: "Pago Exitoso!",
    paymentExpired: "Pago Expirado",
    paymentError: "Error de Pago",
    viewMyItems: "Ver Mis Objetos",
    backToMyItems: "Volver a Mis Objetos",
    // Chat
    typeMessage: "Escribe un mensaje...",
    send: "Enviar",
    noMessages: "Sin mensajes todavia",
    startConversation: "Inicia la conversacion para acordar la devolucion",
    activeChats: "Chats Activos",
    noChats: "Sin chats activos",
    noChatsHint: "Los chats apareceran aqui despues del pago",
    // Notifications
    noNotifications: "Sin notificaciones",
    noNotificationsHint: "Recibiras notificaciones sobre matches y mensajes",
    markAllRead: "Marcar todo como leido",
    // Profile
    memberSince: "Miembro desde",
    itemsLost: "Objetos Perdidos",
    itemsFound: "Objetos Encontrados",
    itemsRecovered: "Objetos Recuperados",
    ratings: "Valoraciones",
    noRatings: "Sin valoraciones todavia",
    rateUser: "Valorar a este usuario",
    // Linked documents
    myDocuments: "Mis Documentos",
    myDocumentsHint: "Vincula tus documentos de identidad para que te avisemos si los encuentran.",
    addDocument: "Añadir documento",
    noDocumentsYet: "Aún no has vinculado ningún documento",
    linkedOn: "Vinculado el",
    docTypeIdCard: "DNI / NIE",
    docTypePassport: "Pasaporte",
    docTypeDrivingLicense: "Carnet de conducir",
    docTypeOther: "Otro",
    docTypeLabel: "Etiqueta del documento (opcional)",
    docTypeLabelHint: "Ej. \"DNI\", \"Pasaporte UK\" — solo para mostrar",
    docNumber: "Número del documento",
    docNumberHint: "Espacios y guiones se ignoran",
    docPrivacyNotice: "Solo guardamos un hash irreversible. El número nunca se guarda en claro.",
    linkDocPrivacyNotice: "Escaneamos la foto para verificar el documento, guardamos solo un hash irreversible del número y descartamos la imagen. No conservamos nada en nuestros servidores.",
    linkDocUploadHint: "Sube una foto de tu DNI, NIE, pasaporte o carnet de conducir. Puedes añadir una segunda foto para el reverso.",
    linkDocSelectPhoto: "Seleccionar foto",
    linkDocFilesSelected: "{count} foto(s) seleccionada(s)",
    linkDocVerifyAndLink: "Verificar y vincular",
    linkDocVerifying: "Verificando…",
    linkDocInvalidFile: "Imagen no válida. Sube un JPG, PNG o WebP.",
    linkDocNotDetected: "No hemos podido leer un documento de identidad en la foto. Prueba con una imagen más nítida.",
    linkDocNotGenuine: "Esto no parece un documento auténtico. No aceptamos impresiones, fotocopias ni capturas de pantalla.",
    linkDocUnsupportedType: "Solo se pueden vincular DNI, NIE, pasaportes y carnets de conducir.",
    linkDocNameMismatch: "El nombre del documento no coincide con el de tu perfil. Actualiza tu perfil si es necesario.",
    linkDocDuplicate: "Este documento ya está vinculado a tu perfil.",
    claimIdentifiedTitle: "Reclama tu documento",
    claimIdentifiedIntro: "Un objeto encontrado coincide con un documento vinculado a tu perfil. Revisa los datos y reclámalo.",
    claimIdentifiedProof: "No hace falta responder preguntas: el número del documento coincide criptográficamente.",
    claimIdentifiedConfirm: "Confirmar y reclamar",
    claimIdentifiedSubmitting: "Reclamando…",
    claimExternallyContactedTitle: "El trobador ya te ha contactado",
    claimExternallyContactedBody: "Puede que se hayan puesto en contacto por teléfono o email. Aun así puedes reclamar aquí para gestionar la recuperación a través de la plataforma.",
    maxDocumentsReached: "Has alcanzado el límite de 5 documentos vinculados",
    documentAlreadyLinked: "Este documento ya está vinculado",
    confirmRemoveDocument: "¿Eliminar este documento vinculado?",
    // Identified owner (C2C publish flow)
    identifiedOwner: "Propietario identificado",
    identifiedOwnerHintC2C: "Si el objeto encontrado contiene un documento de identidad, escanéalo para avisar directamente a su propietario. La foto se procesa en memoria y no se almacena.",
    identifiedOwnerUploadBtn: "Escanear documento",
    identifiedOwnerExtracting: "Extrayendo datos...",
    identifiedOwnerNotDetected: "No se ha detectado ningún documento. Prueba con una imagen más nítida.",
    identifiedOwnerRemove: "Eliminar propietario identificado",
    identifiedOwnerInvalidFile: "Tipo de archivo no admitido.",
    identifiedOwnerTooLarge: "Imagen demasiado grande (máx. 10MB).",
    identifiedOwnerPrivacyC2C: "Protegemos la privacidad del propietario. Los datos del documento se almacenan cifrados. Tras enviarlo, NO podrás volver a ver esta información — solo el propietario verificado podrá.",
    docTypeField: "Tipo de documento",
    docNumberField: "Número del documento",
    ownerNameField: "Nombre del propietario",
    // Settings
    language: "Idioma",
    english: "Ingles",
    spanish: "Espanol",
    catalan: "Catalan",
    saveChanges: "Guardar Cambios",
    dangerZone: "Zona de Peligro",
    deleteAccount: "Eliminar Cuenta",
    // General
    loading: "Cargando...",
    error: "Algo salio mal",
    errorPageTitle: "Algo ha ido mal",
    errorPageMessage: "Ha ocurrido un error inesperado. Por favor, intentalo de nuevo.",
    errorLoadData: "No se han podido cargar los datos. Intentalo de nuevo.",
    goHome: "Ir al Inicio",
    retry: "Reintentar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    editLost: "Editar Objeto Perdido",
    editFound: "Editar Objeto Encontrado",
    itemUpdated: "Objeto actualizado! Recalculando matches...",
    close: "Cerrar",
    search: "Buscar",
    viewDetails: "Ver Detalles",
    eurSymbol: "EUR",
    confirmAction: "Estas seguro?",
    confirmRejectMatch: "Esto rechazara el match. Esta accion no se puede deshacer.",
    confirmCancelPayment: "Esto cancelara el pago y emitira un reembolso.",
    confirmRecoveryAction: "Esto confirmara que has recuperado tu objeto y liberara el pago al encontrador.",
    noPaymentSession: "No se encontro sesion de pago",
    paymentTimeout: "La verificacion del pago ha expirado. Por favor revisa tus notificaciones.",
    paymentSessionExpired: "La sesion de pago ha expirado. Por favor intentalo de nuevo.",
    timeAgo: "hace",
    justNow: "Ahora mismo",
    minutesAgo: "hace {n}m",
    hoursAgo: "hace {n}h",
    daysAgo: "hace {n}d",
    // Wallet
    walletBalance: "Saldo del Monedero",
    walletHint: "Gana recompensas devolviendo objetos encontrados. Usa tu saldo para pagar futuros matches.",
    walletHistory: "Historial de Transacciones",
    noTransactions: "Sin transacciones todavia",
    showAll: "Ver todo",
    useWalletBalance: "Usar saldo del monedero",
    availableBalance: "Disponible",
    fullBalancePayment: "El importe completo se pagara desde tu saldo.",
    fromBalance: "Desde saldo",
    fromStripe: "Via Stripe",
    balancePaymentNote: "El pago se deducira al instante de tu monedero. Sin redireccion.",
    payWithBalance: "Pagar con Saldo",
    paidWithBalance: "Pagado con saldo del monedero!",
    // Envío a domicilio
    continue: "Continuar",
    paymentFailed: "El pago ha fallado",
    deliveryHowReceive: "Recupera tu objeto",
    deliveryWhereTo: "¿A dónde?",
    deliveryPickup: "Recogerlo",
    deliveryPickupDesc: "En el establecimiento",
    deliveryFree: "Gratis",
    deliveryShip: "Que me lo envíen",
    deliveryShipDesc: "Llega en 2–4 días",
    deliveryFrom: "desde {price}",
    deliveryContinueToPay: "Continuar · pagar {amount}",
    deliveryPickupNote: "Recogida seleccionada · nada que gestionar",
    deliveryShipNextNote: "Siguiente: dirección y cobertura",
    deliveryName: "Nombre completo",
    deliveryAddress1: "Dirección",
    deliveryAddress2: "Piso, puerta (opcional)",
    deliveryCity: "Ciudad",
    deliveryPostal: "Código postal",
    deliveryCountry: "País",
    deliveryCountryHint: "Código de 2 letras, ej. ES",
    deliveryCoverIncluded: "Cubierto hasta {amount} — incluido",
    deliveryCoverIncludedDesc: "No hay que rellenar nada salvo que valga más.",
    deliveryExtraCover: "Vale más de {amount}",
    deliveryExtraCoverDesc: "Añade cobertura extra · {rate}% del valor por encima de {amount}",
    deliveryDeclaredValuePlaceholder: "Valor del objeto",
    deliveryReviewPay: "Revisar y pagar",
    deliveryAddressIncomplete: "Completa la dirección para continuar",
    deliveryHomeDelivery: "Envío a domicilio",
    deliveryHeavy: "Pesa más de 1 kg",
    deliveryHeavyDesc: "Hasta 1 kg está incluido. Indica el peso para calcular el transporte.",
    deliveryWeightPlaceholder: "Peso",
    deliveryHowShips: "Cómo se envía",
    deliveryRatesLoading: "Calculando precios de envío…",
    deliveryStandard: "Envío estándar",
    deliveryEtaDays: "{days} días laborables",
    deliveryEtaRange: "{min}–{max} días laborables",
    deliveryExtraCoverLine: "Cobertura extra",
    deliveryPayNote: "Cubierto hasta {amount} en tránsito · seguro con Stripe",
    deliveryPayAmount: "Pagar {amount}",
    deliveryConfirmPickup: "Confirmar recogida",
    deliveryPickupConfirmed: "Recogida confirmada — recógelo en persona",
    deliveryCoveredPickupNote: "Tu organización cubre la recuperación — no pagas nada por la recogida en persona.",
    shipStage_preparing: "Preparando tu paquete",
    shipStage_shipped: "En camino",
    shipStage_out_for_delivery: "En reparto",
    shipStage_delivered: "Entregado",
    shipStage_issue: "Hay una incidencia",
    shipStage_cancelled: "Envío cancelado",
    shipToCity: "Envío a {city}",
    shipTrackingDesc: "Lo mantendremos actualizado a medida que avance",
    shipTrackingNumber: "Número de seguimiento",
    shipTrack: "Seguir",
    shipCovered: "Cubierto hasta {amount} en tránsito",
  },
  ca: {
    // NFC owner-tags
    nfcActivateTitle: "Activa les teves etiquetes",
    nfcActivateDesc: "Introdueix el codi del teu pack per vincular les seves etiquetes NFC al teu compte. Només ho fas un cop per pack — després, només enganxa les etiquetes a les teves coses.",
    nfcActivatePackId: "ID del pack",
    nfcActivateCode: "Codi d'activació",
    nfcActivateBtn: "Activa el pack",
    nfcActivateBusy: "Activant…",
    nfcActivatedTitle: "Pack activat",
    nfcActivatedDesc: "{count} etiquetes ara estan vinculades al teu compte. Enganxa-les a les teves coses i oblida-te'n.",
    nfcGoRekovr: "Ves a Rekovr",
    nfcDone: "Fet",
    nfcFoundInactiveTitle: "Aquesta etiqueta no està activa",
    nfcFoundInactiveDesc: "No hem trobat cap objecte vinculat a aquesta etiqueta.",
    nfcFoundSelfTitle: "Aquest objecte és teu 🙂",
    nfcFoundSelfDesc: "Aquesta etiqueta està vinculada al teu propi compte — no hi ha res a tornar aquí.",
    nfcFoundActiveTitle: "Ja s'està tornant",
    nfcFoundActiveDesc: "Algú ja està ajudant a tornar aquest objecte. Gràcies per escanejar!",
    nfcFoundTitle: "Has trobat l'objecte d'algú",
    nfcFoundDesc: "Confirma que el tens i et connectarem amb el propietari per tornar-lo — guanyaràs una recompensa per ajudar.",
    nfcFoundNoteLabel: "Afegeix una nota (opcional)",
    nfcFoundNotePlaceholder: "p. ex. L'he trobat a la recepció del gimnàs",
    nfcFoundPhotoLabel: "Afegeix una foto (opcional)",
    nfcFoundPhotoAdded: "Foto afegida",
    nfcFoundPhotoChoose: "Tria una foto",
    nfcFoundUploading: "Pujant…",
    nfcFoundConfirm: "Confirmo — ho he trobat",
    nfcFoundConnecting: "Connectant…",
    nfcFoundPrivacy: "El propietari no veu la teva identitat fins que acceptes coordinar.",
    nfcFoundDoneTitle: "Gràcies — has alegrat el dia a algú",
    nfcFoundDoneDesc: "Hem avisat el propietari. Obre la conversa per organitzar el retorn — també t'enviarem un email si respon.",
    nfcFoundDoneBtn: "Obre la conversa",
    nfcTagEditTitle: "La teva etiqueta",
    nfcTagEditDesc: "Afegeix detalls per saber què hi ha en aquesta etiqueta — i posa una recompensa per motivar qui la trobi. Tot és opcional.",
    nfcTagAiHint: "Consell: afegeix una foto i deixa que la IA ompli el nom i la descripció.",
    nfcTagNameLabel: "Nom",
    nfcTagNamePlaceholder: "p. ex. Cartera de pell marró",
    nfcTagDescLabel: "Descripció",
    nfcTagRewardLabel: "Recompensa (€)",
    nfcTagSave: "Desa els detalls",
    nfcTagSaving: "Desant…",
    nfcTagSavedTitle: "Detalls desats",
    nfcTagSavedDesc: "Genial — ara sabràs exactament què hi ha en aquesta etiqueta, i qui la trobi també ho veurà.",
    // Navigation
    home: "Inici",
    myItems: "Els Meus Objectes",
    messages: "Missatges",
    notifications: "Notificacions",
    profile: "Perfil",
    settings: "Configuracio",
    report: "Reportar",
    // Auth
    login: "Iniciar Sessio",
    register: "Registrar-se",
    loginWithGoogle: "Continuar amb Google",
    email: "Correu electronic",
    password: "Contrasenya",
    name: "Nom",
    orContinueWith: "o continuar amb",
    alreadyHaveAccount: "Ja tens un compte?",
    dontHaveAccount: "No tens un compte?",
    logout: "Tancar Sessio",
    loginTagline: "Recupera el que importa.",
    orDivider: "o",
    termsNotice: "En continuar acceptes els nostres Termes i Politica de Privacitat.",
    verifyYourEmail: "Verifica el teu email",
    verificationCodeSent: "Hem enviat un codi de 6 digits a",
    enterCode: "Introdueix el codi",
    codePlaceholder: "000000",
    verify: "Verificar",
    verifying: "Verificant...",
    resendCode: "Reenviar codi",
    codeSent: "Codi enviat!",
    codeExpired: "Codi caducat. Sol-licita'n un de nou.",
    invalidCode: "Codi incorrecte. Torna-ho a provar.",
    emailVerified: "Email verificat!",
    backToLogin: "Tornar al login",
    magicLinkExpired: "Aquest enllaç ha caducat. Inicia sessió manualment.",
    loggingIn: "Iniciant sessió...",
    // Home
    welcomeTitle: "Recupera el que importa.",
    welcomeSubtitle: "La plataforma d'objectes perduts i trobats.",
    iLostSomething: "He perdut alguna cosa",
    iFoundSomething: "He trobat alguna cosa",
    howItWorks: "Com funciona",
    stepReport: "Reportar",
    stepReportDesc: "Descriu el teu objecte amb detalls, fotos i ubicacio.",
    stepAiMatching: "Matching amb IA",
    stepAiMatchingDesc: "La nostra IA compara objectes perduts i trobats automaticament.",
    stepSecureReturn: "Devolucio Segura",
    stepSecureReturnDesc: "Xateja en privat, quedada segura i completa l'intercanvi.",
    reportAndLetAiFind: "Reporta i deixa que la IA ho trobi",
    helpReturnToOwner: "Ajuda a retornar-ho al seu propietari",
    // Invitaci\u00f3 a reclamar (iniciada per l'operari)
    claimInviteTitle: "Reclama el que has perdut",
    claimInviteWrongAccount: "Tens la sessi\u00f3 iniciada amb un altre compte en aquest dispositiu.",
    claimInviteWrongAccountWho: 'Sessi\u00f3 de {current} \u00b7 convidat: {invited}',
    claimInviteSwitchAccount: 'Tanca la sessi\u00f3 i continua com a {invited}',
    claimInviteIntro: "{org} creu que ha trobat una cosa teva. Comprova que encaixa i continua per demostrar que \u00e9s teva.",
    claimInviteIntroNoOrg: "Una organitzaci\u00f3 creu que ha trobat una cosa teva. Comprova que encaixa i continua per demostrar que \u00e9s teva.",
    claimInviteFoundBy: "Trobat per {org}",
    claimInviteFoundItem: "Objecte trobat",
    claimInviteVeilNote: "El t\u00edtol real i la foto es mantenen ocults fins que responguis unes preguntes sobre l'objecte.",
    claimInviteNameLabel: "El teu nom",
    claimInviteNamePlaceholder: "Com t'hem de dir?",
    claimInviteAccountNote: "Et crearem el compte amb {email}.",
    claimInviteContinue: "Continua",
    claimInviteAccepting: "Ho estem preparant\u2026",
    claimInviteNotMine: "Si no \u00e9s teu, tanca aquesta p\u00e0gina. No passa res.",
    claimInviteExpiredTitle: "Aquest enlla\u00e7 ha caducat",
    claimInviteExpiredBody: "Les invitacions duren 48 hores. Torna a trucar a l'organitzaci\u00f3 i te'n podran enviar una de nova.",
    claimInviteCancelledTitle: "Aquesta invitaci\u00f3 s'ha retirat",
    claimInviteCancelledBody: "L'organitzaci\u00f3 l'ha cancel\u00b7lat. Posa't en contacte amb ells si creus que \u00e9s un error.",
    claimInviteGoneTitle: "Aquest objecte ja s'ha entregat",
    claimInviteGoneBody: "Alg\u00fa el va recollir abans que hi arribessis. Contacta amb l'organitzaci\u00f3 si creus que era teu.",
    claimInviteNotFoundTitle: "No trobem aquesta invitaci\u00f3",
    claimInviteNotFoundBody: "Pot ser que l'enlla\u00e7 estigui incomplet. Torna a obrir-lo des del correu o demana que te'l reenvi\u00efn.",
    // Safata de tasques de l'inici
    trayGreeting: "Hola, {name}",
    trayAllCaughtUp: "Tot al dia",
    trayAllCaughtUpDesc: "No tens res pendent. Els teus anuncis segueixen buscant.",
    trayThingsToDoOne: "1 cosa per fer",
    trayThingsToDoMany: "{count} coses per fer",
    trayYourTurn: "Et toca a tu",
    trayInProgress: "En curs",
    trayNothingElse: "No tens res m\u00e9s en marxa.",
    trayLoadFailed: "No hem pogut carregar les teves tasques.",
    trayRetry: "Torna-ho a provar",
    publishLostShort: "He perdut\u2026",
    publishFoundShort: "He trobat\u2026",
    trayFoundAt: "Troballa a {place}",
    trayGroupedHint: "Tria per on comences",
    trayFinderRole: "Ets el trobador",
    trayReleasesPayment: "Allibera el pagament",
    taskAnswerVerification: "Respon les preguntes de verificaci\u00f3",
    taskAnswerVerificationOne: "Respon 1 pregunta de verificaci\u00f3",
    taskAnswerVerificationMany: "Respon {count} preguntes de verificaci\u00f3",
    taskProvideProof: "Aporta m\u00e9s proves de propietat",
    taskChooseDelivery: "Tria com el vols recuperar",
    taskPayRecovery: "Completa el pagament de la recuperaci\u00f3",
    taskShowPickupQr: "Ensenya el QR quan el recullis",
    taskConfirmRecovery: "Confirma que ho has recuperat",
    taskShipmentIssue: "Hi ha un problema amb l'enviament",
    taskDecideMatch: "Decideix sobre un match nou",
    taskReviewAnswers: "Revisa les respostes de verificaci\u00f3",
    taskReviewAnswersOne: "Revisa 1 resposta de verificaci\u00f3",
    taskReviewAnswersMany: "Revisa {count} respostes de verificaci\u00f3",
    taskGroupedAnswerVerification: "{count} matches per verificar",
    taskGroupedReviewAnswers: "{count} matches per revisar",
    taskGroupedDecideMatch: "{count} matches per decidir",
    taskGroupedGeneric: "{count} coses pendents",
    waitFinder: "Esperant que el trobador decideixi",
    waitClaimant: "Esperant la persona que ho ha perdut",
    waitShipmentPreparing: "Preparant l'enviament",
    waitShipmentOnTheWay: "En cam\u00ed",
    waitHandover: "Pendent de l'entrega en m\u00e0",
    openMatchesBadge: "{count} oberts",
    // Publish
    publishLost: "Reportar Objecte Perdut",
    publishFound: "Reportar Objecte Trobat",
    reportAnItem: "Reportar un Objecte",
    reportLostDesc: "Reporta un objecte perdut i deixa que la IA el busqui",
    reportFoundDesc: "Ajuda a retornar-ho al seu legitim propietari",
    title: "Titol",
    titlePlaceholder: "Ex: iPhone 14 Pro negre",
    description: "Descripcio",
    descriptionPlaceholder: "Descriu l'objecte amb el maxim detall possible...",
    location: "Ubicacio",
    locationPlaceholder: "Buscar una adreca...",
    dateTime: "Data i Hora",
    whenDidThisHappen: "Quan va passar?",
    tapMapOrSearch: "Toca el mapa o busca una adreca",
    photos: "Fotos",
    photosHint: "Fins a 5 fotos (recomanat)",
    maxPhotos: "Maxim 5 fotos",
    aiGenerateDescription: "Omplir títol i descripció",
    aiGenerating: "Analitzant fotos...",
    aiGenerateHint: "Afegeix fotos per generar títol i descripció automàticament",
    aiGenerateSuccess: "Descripció generada!",
    aiGenerateError: "No s'ha pogut generar la descripció",
    reward: "Recompensa",
    rewardHint: "Minim 5 EUR si s'especifica",
    rewardPlaceholder: "0",
    howRewardsWork: "Com funcionen les recompenses",
    rewardExplanation1: "La recompensa incentiva els trobadors a retornar el teu objecte. Una recompensa justa augmenta les teves possibilitats.",
    rewardExplanation2: "Nomes pagues si recuperes el teu objecte. Sense match = sense carrec.",
    rewardExplanation3: "Els diners es retenen de forma segura per Rekovr fins que confirmis la recuperacio. Cancel-la en qualsevol moment per un reemborsament complet.",
    rewardCommission: "El trobador rep la teva recompensa íntegra. La comissió de Rekovr s'afegeix a part i es mostra abans de pagar.",
    rewardToFinder: "Recompensa per al trobador",
    rewardYouWillPay: "Pagaràs",
    rewardEstimateNote: "Aproximat: la comissió final depèn de la categoria de l'objecte.",
    rewardMotivationTitle: "Ofereix una recompensa al trobador",
    rewardMotivationBody: "Els objectes amb recompensa tenen moltes més possibilitats de ser retornats. Només pagues si recuperes el teu objecte — sense recuperació, sense càrrec.",
    rewardSkip: "Continuar sense recompensa",
    rewardNoRewardNote: "Pots recuperar el teu objecte sense recompensa, però les possibilitats són menors.",
    next: "Seguent",
    back: "Enrere",
    submit: "Enviar",
    publishing: "Publicant...",
    lostItemReported: "Objecte perdut reportat! Buscant coincidencies...",
    foundItemReported: "Objecte trobat reportat!",
    readyToSubmit: "Tot llest — ja pots enviar.",
    step: "Pas",
    of: "de",
    itemDetails: "Detalls de l'Objecte",
    locationAndTime: "Ubicacio i Hora",
    reviewAndSubmit: "Revisar i Enviar",
    summary: "Resum",
    type: "Tipus",
    // Items
    lost: "Perdut",
    found: "Trobat",
    active: "Actiu",
    recovered: "Recuperat",
    returned: "Retornat",
    archived: "Arxivat",
    matched: "Amb Match",
    noItems: "Sense objectes encara",
    noItemsHint: "Comenca reportant un objecte perdut o trobat",
    category: "Categoria",
    postedOn: "Publicat el",
    expiresOn: "Caduca el",
    // Matches
    possibleMatch: "Possible Match",
    matchScore: "Puntuacio del Match",
    matchDetails: "Detalls del Match",
    accept: "Acceptar",
    reject: "Rebutjar",
    provideProof: "Aportar mes informacio",
    matchAccepted: "Match acceptat!",
    matchRejected: "Match rebutjat",
    proofSubmitted: "Prova enviada",
    contactInfoDetected: "Hem detectat informació de contacte al teu text. Per seguretat, aquesta informació no serà visible per l'altra part.",
    continueToPayment: "Continuar al Pagament",
    openChat: "Obrir Xat",
    additionalInfo: "Informacio Addicional",
    proofPlaceholder: "Descriu detalls addicionals que demostrin la propietat...",
    rewardAmount: "Import de la recompensa",
    totalToPay: "Total a pagar",
    breakdownDetails: "Veure desglossament",
    platformFee: "Comissio de la plataforma",
    requestMoreInfo: "Sol·licitar Més Informació",
    infoRequested: "Sol·licitud d'informació enviada!",
    infoAlreadyRequested: "Informació Ja Sol·licitada",
    infoRequestedTitle: "Cal més informació",
    infoRequestedMessage: "El trobador necessita més detalls per verificar que n'ets el propietari. Si us plau, aporta informació addicional usant el botó de sota.",
    confirmRequestInfo: "Es notificarà al propietari que necessites més informació per verificar la seva propietat. Se li demanarà que aporti detalls addicionals.",
    foundByOrg: "Trobat per",
    noMatches: "Sense matches encara",
    noMatchesHint: "Et notificarem quan trobem un possible match",
    addPhotos: "Afegeix fotos",
    addPhotosHint: "Els objectes amb fotos tenen moltes mes probabilitats de match",
    matchVerdictHigh: "Coincidencia alta",
    matchVerdictMedium: "Coincidencia possible",
    matchVerdictLow: "Coincidencia baixa",
    showMore: "Mostra mes",
    showLess: "Mostra menys",
    apart: "de diferencia",
    protectedVersion: "Versio resumida",
    answerQuestions: "Respon les preguntes",
    yourAnswers: "Les teves respostes",
    activeMatches: "Actius",
    allMatches: "Tots",
    loadMore: "Carregar més",
    pending: "Pendent",
    pending_verification: "Verificació",
    pending_review: "En revisió",
    accepted: "Acceptat",
    rejected: "Rebutjat",
    dismissed: "Descartat",
    paid: "Pagat",
    // Verification
    pendingVerification: "Verificació",
    verificationRequired: "Verificació de propietat",
    verificationDescription: "Si us plau, respon unes preguntes per verificar que ets el propietari d'aquest objecte. Això ajuda a assegurar que els objectes es retornen a la persona correcta.",
    // M3+ — AI recommendation card for the finder
    aiRecommendsSkip: "La IA recomana acceptar directament",
    aiRecommendsVerify: "La IA recomana fer preguntes de verificació",
    acceptDirectly: "Accepta directament",
    acceptAnyway: "Accepta igualment",
    askVerificationQuestions: "Demana verificació",
    verificationRequested: "Verificació demanada",
    finderDecisionAdvisory: "Si acceptes sense verificació, confies que la descripció del propietari coincideix amb el teu objecte. La verificació és una manera ràpida d'evitar errors.",
    noVerificationQuestionsAvailable: "No s'han pogut generar preguntes de verificació per a aquest match.",
    // M4 — free-text fallback
    freetextFallbackBody: "Descriu tot el que recordis sobre el teu objecte: contingut, marques distintives, on i quan el vas perdre, qualsevol cosa que ajudi a confirmar que és teu.",
    freetextPlaceholder: "Descriu el teu objecte amb detall...",
    submitDescription: "Envia descripció",
    photosLockedMessage: "Les fotos es desbloquejaran després de la verificació",
    publicCopyPendingTitle: "Objecte trobat",
    publicCopyPendingDesc: "La descripció segura d'aquest anunci encara s'està preparant.",
    claimantPendingMessage: "El trobador està revisant la teva sol·licitud. Pot acceptar-la directament o fer-te unes preguntes per confirmar que l'objecte és teu.",
    claimantPendingVerificationMessage: "Respon les preguntes de verificació de sota per demostrar que l'objecte és teu. Només el propietari real n'hauria de ser capaç.",
    photosLockedClosedMessage: "Les fotos queden ocultes en una coincidència tancada",
    submitVerification: "Enviar respostes",
    verificationSubmitted: "Respostes enviades correctament!",
    verificationFailed: "Error en enviar les respostes. Torna-ho a provar.",
    answerPlaceholder: "Escriu la teva resposta...",
    pendingReview: "En revisió",
    pendingReviewClaimantTitle: "Respostes enviades",
    pendingReviewClaimantMessage: "Les teves respostes han estat enviades i s'estan revisant. Se't notificarà quan el trobador prengui una decisió.",
    verificationPassedClaimantTitle: "Verificació superada",
    verificationPassedClaimantMessage: "Gràcies! Ja tenim tot el que necessitàvem de tu. Ara el trobador revisarà el match — pot acceptar-lo directament o demanar-te algun detall extra. T'avisarem tan bon punt hi hagi novetats.",
    verificationScore: "Puntuació de verificació",
    verificationDetails: "Detalls de verificació",
    claimantAnswer: "Resposta del reclamant",
    aiAssessment: "Avaluació IA",
    verificationHigh: "Alta confiança",
    verificationMedium: "Requereix revisió",
    verificationLow: "Baixa confiança",
    // Payment
    makePayment: "Realitzar Pagament",
    recoveryFee: "Tarifa de recuperació",
    recoveryCoveredByOrg: "No has de pagar res",
    recoveryCoveredByOrgDesc: "El cost del servei està cobert per l'organització. Gaudeix de la recuperació!",
    recoveryCoveredByOrgDescWithName: "El cost del servei està cobert per {name}. Gaudeix de la recuperació!",
    betaFreeRecoveryTitle: "Recuperació gratuïta durant la beta",
    betaFreeRecoveryDesc: "Estem en beta — les recuperacions són gratuïtes ara mateix. Quan el trobador accepti, podràs contactar-hi directament sense cap pagament.",
    betaFreeNoReward: "La recuperació és gratuïta durant la beta — no cal indicar recompensa.",
    finderWaitingVerificationTitle: "Verificació sol·licitada",
    finderWaitingVerificationDesc: "Esperant que la persona que ha perdut l'objecte respongui les preguntes de verificació. T'avisarem tan bon punt contesti.",
    recoveryCoveredByOrgPickupTitle: "Instruccions de recollida",
    recoveryCoveredByOrgPickupHint: "Mostra el codi QR al punt de recollida per recuperar el teu objecte.",
    feeLoading: "Calculant tarifa...",
    pickupQR: "Codi QR de recollida",
    pickupQRDescription: "Mostra aquest codi QR al recinte per recollir el teu objecte",
    downloadQR: "Descarregar codi QR",
    pickupCodeLabel: "O dicta el codi",
    pickupCodeHint: "Si no et poden escanejar el QR, dicta aquest codi o copia'l.",
    copyPickupCode: "Copiar codi de recollida",
    copied: "Copiat al porta-retalls",
    paymentHeld: "Pagament Retingut",
    confirmRecovery: "He recuperat el meu objecte",
    cancelPayment: "Cancel-lar i Reemborsar",
    paymentAmount: "Import del Pagament",
    commission: "Comissio Rekovr",
    finderReceives: "El Trobador Rep",
    paymentMock: "Aquest es un pagament simulat per al MVP",
    paymentRedirectNote: "Seras redirigit a Stripe per completar el pagament de forma segura. Els fons es retindran fins que confirmis la recuperacio de l'objecte.",
    recoveryConfirmed: "Recuperacio confirmada! Gracies!",
    paymentRefunded: "Pagament reemborsat",
    processingPayment: "Processant Pagament...",
    pleaseWaitPayment: "Si us plau espera mentre confirmem el teu pagament",
    paymentSuccessful: "Pagament Reeixit!",
    paymentExpired: "Pagament Expirat",
    paymentError: "Error de Pagament",
    viewMyItems: "Veure Els Meus Objectes",
    backToMyItems: "Tornar als Meus Objectes",
    // Chat
    typeMessage: "Escriu un missatge...",
    send: "Enviar",
    noMessages: "Sense missatges encara",
    startConversation: "Inicia la conversa per acordar la devolucio",
    activeChats: "Xats Actius",
    noChats: "Sense xats actius",
    noChatsHint: "Els xats apareixeran aqui despres del pagament",
    // Notifications
    noNotifications: "Sense notificacions",
    noNotificationsHint: "Rebras notificacions sobre matches i missatges",
    markAllRead: "Marcar tot com a llegit",
    // Profile
    memberSince: "Membre des de",
    itemsLost: "Objectes Perduts",
    itemsFound: "Objectes Trobats",
    itemsRecovered: "Objectes Recuperats",
    ratings: "Valoracions",
    noRatings: "Sense valoracions encara",
    rateUser: "Valorar aquest usuari",
    // Linked documents
    myDocuments: "Els meus documents",
    myDocumentsHint: "Vincula els teus documents d'identitat perquè et puguem avisar si algú els troba.",
    addDocument: "Afegir document",
    noDocumentsYet: "Encara no has vinculat cap document",
    linkedOn: "Vinculat el",
    docTypeIdCard: "DNI / NIE",
    docTypePassport: "Passaport",
    docTypeDrivingLicense: "Carnet de conduir",
    docTypeOther: "Altre",
    docTypeLabel: "Etiqueta del document (opcional)",
    docTypeLabelHint: "Ex. \"DNI\", \"Passaport UK\" — només per mostrar",
    docNumber: "Número del document",
    docNumberHint: "Els espais i guions s'ignoren",
    docPrivacyNotice: "Només guardem un hash irreversible. El número mai s'emmagatzema en clar.",
    linkDocPrivacyNotice: "Escanegem la foto per verificar el document, guardem només un hash irreversible del número i descartem la imatge. No conservem res als nostres servidors.",
    linkDocUploadHint: "Puja una foto del teu DNI, NIE, passaport o carnet de conduir. Pots afegir una segona foto pel revers.",
    linkDocSelectPhoto: "Selecciona una foto",
    linkDocFilesSelected: "{count} foto(s) seleccionada(es)",
    linkDocVerifyAndLink: "Verifica i vincula",
    linkDocVerifying: "Verificant…",
    linkDocInvalidFile: "Imatge no vàlida. Puja un JPG, PNG o WebP.",
    linkDocNotDetected: "No hem pogut llegir cap document d'identitat a la foto. Prova amb una imatge més nítida.",
    linkDocNotGenuine: "Això no sembla un document autèntic. No acceptem impressions, fotocòpies ni captures de pantalla.",
    linkDocUnsupportedType: "Només es poden vincular DNI, NIE, passaports i carnets de conduir.",
    linkDocNameMismatch: "El nom del document no coincideix amb el del teu perfil. Actualitza el perfil si cal.",
    linkDocDuplicate: "Aquest document ja està vinculat al teu perfil.",
    claimIdentifiedTitle: "Reclama el teu document",
    claimIdentifiedIntro: "Un objecte trobat coincideix amb un document vinculat al teu perfil. Revisa les dades i reclama'l.",
    claimIdentifiedProof: "No cal respondre preguntes: el número del document coincideix criptogràficament.",
    claimIdentifiedConfirm: "Confirma i reclama",
    claimIdentifiedSubmitting: "Reclamant…",
    claimExternallyContactedTitle: "El trobador ja t'ha contactat",
    claimExternallyContactedBody: "És possible que s'hagin posat en contacte per telèfon o email. Tot i així pots reclamar aquí per gestionar la recuperació a través de la plataforma.",
    maxDocumentsReached: "Has arribat al límit de 5 documents vinculats",
    documentAlreadyLinked: "Aquest document ja està vinculat",
    confirmRemoveDocument: "Vols eliminar aquest document vinculat?",
    // Identified owner (C2C publish flow)
    identifiedOwner: "Propietari identificat",
    identifiedOwnerHintC2C: "Si l'objecte trobat conté un document d'identitat, escaneja'l per avisar directament el propietari. La foto es processa en memòria i no s'emmagatzema.",
    identifiedOwnerUploadBtn: "Escanejar document",
    identifiedOwnerExtracting: "Extraient dades...",
    identifiedOwnerNotDetected: "No s'ha detectat cap document. Prova amb una imatge més nítida.",
    identifiedOwnerRemove: "Eliminar propietari identificat",
    identifiedOwnerInvalidFile: "Tipus de fitxer no admès.",
    identifiedOwnerTooLarge: "Imatge massa gran (màx. 10MB).",
    identifiedOwnerPrivacyC2C: "Protegim la privacitat del propietari. Les dades del document s'emmagatzemen xifrades. Un cop enviat, NO podràs tornar a veure aquesta informació — només el propietari verificat ho podrà fer.",
    docTypeField: "Tipus de document",
    docNumberField: "Número del document",
    ownerNameField: "Nom del propietari",
    // Settings
    language: "Idioma",
    english: "Angles",
    spanish: "Espanyol",
    catalan: "Catala",
    saveChanges: "Guardar Canvis",
    dangerZone: "Zona de Perill",
    deleteAccount: "Eliminar Compte",
    // General
    loading: "Carregant...",
    error: "Alguna cosa ha anat malament",
    errorPageTitle: "Alguna cosa ha anat malament",
    errorPageMessage: "S'ha produït un error inesperat. Si us plau, torna-ho a intentar.",
    errorLoadData: "No s'han pogut carregar les dades. Torna-ho a intentar.",
    goHome: "Anar a l'Inici",
    retry: "Reintentar",
    cancel: "Cancel-lar",
    confirm: "Confirmar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    editLost: "Editar Objecte Perdut",
    editFound: "Editar Objecte Trobat",
    itemUpdated: "Objecte actualitzat! Recalculant matches...",
    close: "Tancar",
    search: "Buscar",
    viewDetails: "Veure Detalls",
    eurSymbol: "EUR",
    confirmAction: "N'estas segur?",
    confirmRejectMatch: "Aixo rebutjara el match. Aquesta accio no es pot desfer.",
    confirmCancelPayment: "Aixo cancel-lara el pagament i emetra un reemborsament.",
    confirmRecoveryAction: "Aixo confirmara que has recuperat el teu objecte i alliberara el pagament al trobador.",
    noPaymentSession: "No s'ha trobat sessio de pagament",
    paymentTimeout: "La verificacio del pagament ha expirat. Si us plau revisa les teves notificacions.",
    paymentSessionExpired: "La sessio de pagament ha expirat. Si us plau torna-ho a intentar.",
    timeAgo: "fa",
    justNow: "Ara mateix",
    minutesAgo: "fa {n}m",
    hoursAgo: "fa {n}h",
    daysAgo: "fa {n}d",
    // Wallet
    walletBalance: "Saldo del Moneder",
    walletHint: "Guanya recompenses retornant objectes trobats. Usa el teu saldo per pagar futurs matches.",
    walletHistory: "Historial de Transaccions",
    noTransactions: "Sense transaccions encara",
    showAll: "Veure tot",
    useWalletBalance: "Usar saldo del moneder",
    availableBalance: "Disponible",
    fullBalancePayment: "L'import complet es pagara des del teu saldo.",
    fromBalance: "Des del saldo",
    fromStripe: "Via Stripe",
    balancePaymentNote: "El pagament es deduira al instant del teu moneder. Sense redireccio.",
    payWithBalance: "Pagar amb Saldo",
    paidWithBalance: "Pagat amb saldo del moneder!",
    // Enviament a domicili
    continue: "Continuar",
    paymentFailed: "El pagament ha fallat",
    deliveryHowReceive: "Recupera el teu objecte",
    deliveryWhereTo: "On?",
    deliveryPickup: "Recollir-lo",
    deliveryPickupDesc: "A l'establiment",
    deliveryFree: "Gratis",
    deliveryShip: "Que me l'enviïn",
    deliveryShipDesc: "Arriba en 2–4 dies",
    deliveryFrom: "des de {price}",
    deliveryContinueToPay: "Continuar · pagar {amount}",
    deliveryPickupNote: "Recollida seleccionada · res a gestionar",
    deliveryShipNextNote: "Següent: adreça i cobertura",
    deliveryName: "Nom complet",
    deliveryAddress1: "Adreça",
    deliveryAddress2: "Pis, porta (opcional)",
    deliveryCity: "Ciutat",
    deliveryPostal: "Codi postal",
    deliveryCountry: "País",
    deliveryCountryHint: "Codi de 2 lletres, ex. ES",
    deliveryCoverIncluded: "Cobert fins a {amount} — inclòs",
    deliveryCoverIncludedDesc: "No cal omplir res tret que valgui més.",
    deliveryExtraCover: "Val més de {amount}",
    deliveryExtraCoverDesc: "Afegeix cobertura extra · {rate}% del valor per sobre de {amount}",
    deliveryDeclaredValuePlaceholder: "Valor de l'objecte",
    deliveryReviewPay: "Revisar i pagar",
    deliveryAddressIncomplete: "Completa l'adreça per continuar",
    deliveryHomeDelivery: "Enviament a domicili",
    deliveryHeavy: "Pesa més d'1 kg",
    deliveryHeavyDesc: "Fins a 1 kg està inclòs. Indica el pes per calcular el transport.",
    deliveryWeightPlaceholder: "Pes",
    deliveryHowShips: "Com s'envia",
    deliveryRatesLoading: "Calculant preus d'enviament…",
    deliveryStandard: "Enviament estàndard",
    deliveryEtaDays: "{days} dies laborables",
    deliveryEtaRange: "{min}–{max} dies laborables",
    deliveryExtraCoverLine: "Cobertura extra",
    deliveryPayNote: "Cobert fins a {amount} en trànsit · segur amb Stripe",
    deliveryPayAmount: "Pagar {amount}",
    deliveryConfirmPickup: "Confirmar recollida",
    deliveryPickupConfirmed: "Recollida confirmada — recull-lo en persona",
    deliveryCoveredPickupNote: "La teva organització cobreix la recuperació — no pagues res per la recollida en persona.",
    shipStage_preparing: "Preparant el teu paquet",
    shipStage_shipped: "En camí",
    shipStage_out_for_delivery: "En repartiment",
    shipStage_delivered: "Lliurat",
    shipStage_issue: "Hi ha una incidència",
    shipStage_cancelled: "Enviament cancel·lat",
    shipToCity: "Enviament a {city}",
    shipTrackingDesc: "Ho mantindrem actualitzat a mesura que avanci",
    shipTrackingNumber: "Número de seguiment",
    shipTrack: "Seguir",
    shipCovered: "Cobert fins a {amount} en trànsit",
  }
};

export default translations;
